export default __webpack_public_path__ + "static/media/deleteIcon.6293b78a.svg";